export default __webpack_public_path__ + "static/media/remove.11fe5b97.svg";